import { useEffect } from "react";

// Pull-to-refresh starts from a downward drag while the page is at the top.
// overscroll-behavior stops it on Chrome/Android, but iOS Safari doesn't
// reliably honor that on the page, so those drags are cancelled here too —
// unless something under the finger (the photo editor, a menu) can still
// scroll up.
export const usePreventPullToRefresh = () => {
  useEffect(() => {
    const { documentElement: html, body } = document;
    const previous = [html, body].map((el) =>
      el.style.getPropertyValue("overscroll-behavior-y")
    );
    html.style.setProperty("overscroll-behavior-y", "contain");
    body.style.setProperty("overscroll-behavior-y", "contain");

    let startX = 0;
    let startY = 0;

    const onTouchStart = (event: TouchEvent) => {
      const touch = event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
    };

    const onTouchMove = (event: TouchEvent) => {
      const touch = event.touches[0];
      if (!touch || event.touches.length > 1 || !event.cancelable) return;

      // Sideways swipes, upward drags and a scrolled page all scroll as usual.
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (dy <= Math.abs(dx) || window.scrollY > 0) return;

      for (
        let el = event.target instanceof Element ? event.target : null;
        el && el !== body;
        el = el.parentElement
      ) {
        if (
          el.scrollTop > 0 &&
          /auto|scroll|overlay/.test(getComputedStyle(el).overflowY)
        ) {
          return;
        }
      }
      event.preventDefault();
    };

    document.addEventListener("touchstart", onTouchStart, { passive: true });
    document.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      document.removeEventListener("touchstart", onTouchStart);
      document.removeEventListener("touchmove", onTouchMove);
      html.style.setProperty("overscroll-behavior-y", previous[0] ?? "");
      body.style.setProperty("overscroll-behavior-y", previous[1] ?? "");
    };
  }, []);
};
